import { Box } from "@material-ui/core";

const Terms = () => {
  return (
    <Box p={5} dir="rtl">
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <h1>
        <strong>الشروط والأحكام</strong>
      </h1>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
        }}
      >
        <br />
        <strong>
          <em>
            <span style={{ textDecoration: "underline" }}>شروط الاستخدام</span>
          </em>
        </strong>
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        أ) هذا المستند عبارة عن سجل إلكتروني ينص على شروط وأحكام الوصول أو استخدام موقع www.sporting.qa وتطبيق سبورتينج
        للأجهزة المحمولة أو غيرها من الأجهزة التي يطلق عليها "قنوات / منصات تطبيق سبورتينج" . يرجى قراءة هذه الشروط
        والأحكام بعناية قبل استخدام خدماتنا. إذا كنت لا توافق على هذه الشروط والأحكام ، فيجوز لك الامتناع عن استخدام
        الخدمات الموجودة على "قنوات / منصات تطبيق سبورتينج" ، ونطلب منك بعد ذلك عدم تثبيت التطبيق ولكن التواصل مع فريقنا
        للحصول على أي توضيحات إضافية. عن طريق تثبيت "قنوات / منصات تطبيق سبورتينج" أو تنزيلها أو حتى استخدامها فقط ، من
        خلال التعاقد مع تطبيق سبورتينج مع موافقتك على شروط وأحكام الاستخدام والسياسات الأخرى الخاصة بسبورتينج ( بما في
        ذلك على سبيل المثال لا الحصر ، سياسة الإلغاء واسترداد الأموال ، وسياسة الخصوصية على النحو المنشور في "قنوات /
        منصات تطبيق سبورتينج" من وقت لآخر ، الأمر الذي يعتبر ساري المفعول بداية من تاريخ تنزيل تطبيق سبورتينج أو تثبيته
        أو استخدامه ، وإنشاء عقد ملزم قانونًا للالتزام به.
      </p>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        ب) تتيح Sporting المعاملات بين مختلف البوابات عبر الإنترنت ، والتعامل مع مختلف الخدمات ، وبشكل أساسي في استخدام
        المدفوعات / المدفوعات المقدمة من الرسوم الإدارية ورسوم التسجيل والتزويد ومقدمي الخدمات من الأطراف الثالثة
        ومشتريات المتاجر الإلكترونية وما إلى ذلك من خلال ' ' قنوات / منصات تطبيق سبورتينج " . يمكن للمستخدمين (" مستخدم
        / مستخدمين") اختيار وإجراء الحجز أو الدفع أو تحديد موعد من مجموعة متنوعة من المؤسسات المدرجة والمعروضة للإيجار /
        البيع / التشاور من قبل مختلف البائعين الخارجيين ، بما في ذلك على سبيل المثال لا الحصر الفنادق والمؤسسات والمتاجر
        ذات الصلة بالرياضة ( " البائع / ثانية") ، على 'التطبيق الرياضية القنوات / منصات' و الرياضية تمكن من الوصول
        للقنوات تحفظ هذه الباعة في أماكن مختارة من المدن للخدمة في جميع أنحاء قطر. يشار إلى ” قنوات / منصات تطبيق
        سبورتينج” مجتمعة باسم " الخدمات الرياضية" . بالنسبة لخدمات التوصيل الإضافية المقدمة ، قد تفرض عليك Sporting رسوم
        التوصيل.
      </p>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        <span style={{ textDecoration: "underline" }}>
          <em>
            <strong>استخدام " قنوات / منصات تطبيق سبورتينج "</strong>
          </em>
        </span>
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        وتقدم كل الشروط التجارية / التعاقدية والمتفق عليه بين المستخدمين و البائعون وحدها. تشمل الشروط التجارية /
        التعاقدية على سبيل المثال لا الحصر السعر والضرائب وتكاليف الشحن (إن وجدت) وطرق الدفع وشروط الدفع والتاريخ
        والفترة وطريقة الحجز / التسليم والضمانات المتعلقة بالمنتجات والخدمات وخدمات ما بعد البيع المتعلقة بالمنتجات
        والخدمات . لا تملك Sporting أي سيطرة أو لا تحدد أو تقدم المشورة أو تتدخل بأي شكل من الأشكال في عرض أو قبول هذه
        الشروط التجارية / التعاقدية بين المستخدمين والموردين. ومع ذلك ، قد تقدم Sporting خدمات دعم للبائعين فيما يتعلق
        بتنفيذ الطلبات وتحصيل المدفوعات ومركز الاتصال والخدمات الأخرى ، وفقًا للعقود المستقلة التي تنفذها مع البائعين.
      </p>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        لا تقدم Sporting أي تمثيل أو ضمان فيما يتعلق بتفاصيل العناصر (مثل الملكية القانونية والجدارة الائتمانية والهوية
        وما إلى ذلك) لأي من البائعين. يُنصح بالتحقق بشكل مستقل من حسن نية أي بائع معين تختار التعامل معه على ”قنوات /
        منصات تطبيق سبورتينج” واستخدام أفضل حكم في هذا الشأن. تخضع جميع عروض البائع وعروض الجهات الخارجية لشروط وأحكام
        الطرف المعني. سبورتنج لا تتحمل أي مسؤولية عن مثل هذه العروض.
      </p>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        لا تقدم Sporting أي تمثيل أو ضمان فيما يتعلق بالتفاصيل (مثل الجودة والقيمة وقابلية البيع وما إلى ذلك) للمنتجات
        أو الخدمات المقترح بيعها أو عرضها للبيع أو شراؤها على “ قنوات / منصات تطبيق سبورتينج” ولا تقدم ضمنيًا أو تدعم
        صراحةً أو تصادق على بيع أو شراء أي منتجات أو خدمات على المنصة. لا تتحمل شركة Sporting أي مسؤولية عن أي أخطاء أو
        سهو ، سواء بالنيابة عن نفسها أو نيابة عن أطراف ثالثة.
      </p>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        سبورتينج تعمل على الانترنت بتشغيل " تطبيق سبورتينج " الذي يسرد الخدمات والمواد الممكن شرائها / انجازها ويفترض
        دور الميسر ولا تقوم في أي وقت من الأوقات عقد أي صفقة بين المستخدم والموردين على”قنوات / منصات تطبيق سبورتينج”
        تأتي في أو تستحوذ على أي من المنتجات أو الخدمات التي يقدمها البائع / البائعون. لن يكون لشركة Sporting في أي وقت
        أي حق أو ملكية أو مصلحة على المنتجات كما لا تتحمل Sporting أي التزامات أو مسؤوليات فيما يتعلق بهذا العقد المبرم
        بين المستخدم / المستخدمين والمورد / البائعين.
      </p>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        توفر Sporting فقط "منصة للتواصل" ومن المتفق عليه أن عقد بيع أي من المنتجات أو الخدمات يجب أن يكون عقدًا ثنائيًا
        بين البائع والمستخدم. في حالة وجود شكاوى من المستخدم تتعلق بكفاءة المنتجات / الخدمات أو الجودة أو أي مشكلات أخرى
        من هذا القبيل ، يجب على Sporting إخطار البائع بذلك كما يجب عليه إعادة توجيه المستخدم إلى مركز اتصال المستهلك
        الخاص بالمورد. يكون البائع مسؤولاً عن حل شكاوى المشتري. في حالة قيام المستخدم بتقديم أي شكوى بشأن أي بائع /
        بائعين تم الوصول إليهم باستخدام منصة Sporting ، فسوف نساعد المستخدم بأفضل ما في وسعنا من خلال توفير المعلومات
        ذات الصلة ، مثل تفاصيل البائع والأمر المحدد الذي تتعلق به الشكوى ، لتمكين حل مرضٍ للشكوى.
      </p>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        <span style={{ textDecoration: "underline" }}>
          <em>
            <strong>استخدام الموقع الإلكتروني وتطبيقات سبورتينج ( Android – iOS )</strong>
          </em>
        </span>
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        أنت توافق وتتعهد وتؤكد أن استخدامك لـ “ قنوات / منصات تطبيق سبورتينج” يجب أن يخضع بشكل صارم للمبادئ الملزمة
        التالية:
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        لا يجوز لك استضافة أو عرض أو تحميل أو تنزيل أو تعديل أو نشر أو إرسال أو تحديث أو مشاركة أي معلومات من شأنها:
      </p>
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          تنتمي إلى شخص آخر وليس لك أي حقوق فيها
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          ضار بشكل جسيم ، أو مضايقة ، أو تجديف ، أو تشهيري ، أو فاحش ، أو إباحي ، أو ميول الأطفال ، أو تشهيري ، أو
          افتراء ، أو يحرض أو ينتهك خصوصية الآخرين ، أو يحرض على الكراهية ، أو عنصريًا ، أو عرقيًا ، أو يحط من قدر ، أو
          يتعلق أو يشجع على غسيل الأموال أو المقامرة ، أو غير قانوني بأي شكل آخر في بأي طريقة كانت ؛ أو التهديد غير
          القانوني أو المضايقة بشكل غير قانوني بما في ذلك على سبيل المثال لا الحصر "التمثيل غير اللائق للمرأة"
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          تضليل أو تحريف بأي شكل من الأشكال.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          الإساءة بشكل واضح إلى المجتمع عبر الإنترنت ، مثل المحتوى الجنسي الصريح أو المحتوى الذي يروج للفحش أو الميل
          الجنسي للأطفال أو العنصرية أو التعصب أو الكراهية أو الأذى الجسدي من أي نوع ضد أي مجموعة أو فرد ؛
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          مضايقة المدافعين عن شخص آخر
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          يتضمن نقل "البريد غير الهام" أو "الرسائل المتسلسلة" أو المراسلات الجماعية غير المرغوب فيها أو "البريد
          العشوائي"
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          الترويج لأنشطة أو سلوك غير قانوني مسيء أو مهدد أو فاحش أو تشهيري
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          إنتهاك حقوق أي طرف ثالث [ بما في ذلك ، على سبيل المثال لا الحصر ، حقوق الملكية الفكرية وحقوق الخصوصية ( بما في
          ذلك على سبيل المثال لا الحصر الكشف غير المصرح به عن اسم الشخص أو عنوان البريد الإلكتروني أو العنوان الفعلي أو
          رقم الهاتف) أو حقوق الدعاية [ .
        </li>
      </ul>
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          الترويج لنسخة غير قانونية أو غير مصرح بها من حقوق الطبع والنشر لشخص آخر ، مثل توفير برامج كمبيوتر مقرصنة أو
          روابط لها ، أو توفير معلومات للتحايل على أجهزة حماية النسخ المثبتة في التصنيع ، أو تقديم موسيقى مقرصنة أو
          روابط لملفات الموسيقى المقرصنة
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أن تحتوي على صفحات محظورة أو كلمة مرور فقط ، أو صفحات أو صور مخفية ( تلك غير المرتبطة أو من صفحة أخرى يمكن
          الوصول إليها )
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          توفير المواد التي تستغل الأشخاص بطريقة جنسية أو عنيفة أو بطريقة غير ملائمة أو تطلب معلومات شخصية من أي شخص
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          توفير معلومات إرشادية حول الأنشطة غير القانونية مثل صنع أو شراء أسلحة غير قانونية أو انتهاك خصوصية شخص ما أو
          توفير أو إنشاء فيروسات الكمبيوتر
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أن تحتوي على مقاطع فيديو أو صور فوتوغرافية أو صور لشخص آخر (مع قاصر أو بالغ )
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          محاولة الحصول على وصول غير مصرح به أو يتجاوز نطاق الوصول المصرح به إلى " قنوات / منصات تطبيق سبورتينج" أو إلى
          الملفات الشخصية أو المدونات أو المجتمعات أو معلومات الحساب أو النشرات أو طلبات الصداقة أو مناطق أخرى من "
          قنوات / منصات تطبيق سبورتينج" أو يطلب كلمات مرور أو معلومات تعريف شخصية لأغراض تجارية أو غير قانونية من
          مستخدمين آخرين.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          المشاركة في الأنشطة التجارية و/أو المبيعات دون موافقتنا الخطية المسبقة مثل المسابقات واليانصيب والمقايضة
          والإعلان والمخططات الهرمية أو شراء أو بيع المنتجات المتعلقة بالمنصة. من خلال شروط الاستخدام هذه ، تعني
          الموافقة الكتابية المسبقة لشركة Sporting اتصالاً واردًا من القسم القانوني في Sporting ، استجابةً لطلبك تحديدًا
          ، ويتناول صراحة ويسمح بالنشاط أو السلوك الذي تسعى للحصول على تصريح من أجله
        </li>
      </ul>
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          التماس المقامرة أو الانخراط في أي نشاط قمار يعتبر أو يمكن أن يفسر على أنه غير قانوني
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          التعارض مع استخدام, وتمتع مستخدم آخر بـ “ قنوات / منصات تطبيق سبورتينج” أو أي مستخدم تابع لطرف ثالث والتمتع
          بخدمات مماثلة
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          يشير إلى أي موقع ويب أو عنوان URL يحتوي ، وفقًا لتقديرنا الخاص ، على مواد غير مناسبة لـ “ قنوات / منصات تطبيق
          سبورتينج” أو أي موقع ويب آخر ، أو يحتوي على محتوى قد يكون محظورًا أو ينتهك نصًا أو روحًا من شروط الاستخدام هذه
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          إلحاق الضرر بالقاصرين بأي شكل من الأشكال
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          إنتهاك أي براءة اختراع أو علامة تجارية أو حقوق طبع ونشر أو غيرها من حقوق الملكية الفكرية أو الأسرار التجارية
          لطرف ثالث أو حقوق الدعاية أو الخصوصية أو يجب ألا يكون احتياليًا أو ينطوي على بيع منتجات مزيفة أو مسروقة
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          إنتهاك أي قانون سارٍ في الوقت الحالي
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          خداع أو تضليل المرسل إليه / المستخدمين بشأن أصل هذه الرسائل أو ينقل أي معلومات ذات طبيعة مسيئة أو تنطوي على
          تهديد
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          انتحال شخصية شخص آخر
        </li>
      </ul>
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أن يحتوي على فيروسات برمجية أو أي كود كمبيوتر آخر أو ملفات أو برامج مصممة لمقاطعة أو تدمير أو تقييد وظائف أي
          مورد كمبيوتر ؛ أو يحتوي على أي أحصنة طروادة أو قنابل موقوتة أو برامج إلغاء آلي أو بيض عيد الفصح أو غيرها من
          إجراءات برمجة الكمبيوتر التي قد تلحق الضرر أو تتداخل بشكل ضار مع أو تقلل من قيمة أو تعترض خلسة أو تصادر أي
          نظام أو بيانات أو معلومات شخصية
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          تهديد وحدة قطر أو نزاهتها أو دفاعها أو أمنها أو سيادتها ، أو العلاقات الودية مع الدول الأجنبية ، أو النظام
          العام ، أو يتسبب في التحريض على ارتكاب أي جريمة جنائية أو يمنع التحقيق في أي جريمة أو إهانة أي دولة أخرى
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أن تكون غير صحيحة أو غير دقيقة أو مضللة
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          عروض مباشرة أو غير مباشرة ،محاولات العرض أو المتاجرة أو محاولات المتاجرة في أي عنصر محظور أو مقيد بأي طريقة
          بموجب أحكام أي قانون أو قاعدة أو لائحة أو إرشادات معمول بها في الوقت الحالي ؛ أو تفرض علينا مسؤولية أو تجعلنا
          نخسر ( كليًا أو جزئيًا ) خدمات مزود خدمة الإنترنت أو الموردين الآخرين.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لا يجوز لك استخدام أي "رابط لموضوع معين" أو "صفحة كشط" أو "روبوت" أو "عنكبوت" أو أي جهاز أو برنامج أو خوارزمية
          أو منهجية تلقائية أخرى أو أي عملية يدوية مماثلة أو مكافئة للوصول إلى أو الحصول على أو نسخ أو مراقبة أي جزء من
          " قنوات / منصات تطبيق سبورتينج" أو أي محتوى ، أو إعادة إنتاج أو التحايل بأي شكل من الأشكال على الهيكل الملاحي
          أو عرض “ قنوات / منصات تطبيق سبورتينج” أو أي محتوى ، للحصول على أي مواد أو محاولة الحصول عليها ، المستندات أو
          المعلومات من خلال أي وسيلة لم يتم توفيرها عن قصد من خلال المنصة. نحن نحتفظ بحقنا في حظر أي نشاط من هذا القبيل.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لا يجوز لك محاولة الحصول على وصول غير مصرح به إلى أي جزء أو ميزة من المنصة ، أو أي أنظمة أو شبكات أخرى متصلة
          بـ “ قنوات / منصات تطبيق سبورتينج” أو إلى أي خادم أو كمبيوتر أو شبكة أو أي من الخدمات المقدمة على أو من خلال
          النظام الأساسي ، عن طريق القرصنة أو "التنقيب عن كلمات المرور" أو أي وسيلة أخرى غير مشروعة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لا يجوز لك فحص أو اختبار نقاط الضعف في “ قنوات / منصات تطبيق سبورتينج” أو أي شبكة متصلة بـ “ قنوات / منصات
          تطبيق سبورتينج” ولا تنتهك إجراءات الأمان أو المصادقة على “ قنوات / منصات تطبيق سبورتينج” أو أي منها شبكة متصلة
          بالمنصة. لا يجوز لك عكس البحث أو التتبع أو السعي لتتبع أي معلومات عن أي مستخدم أو زائر آخر للمنصة ، أو أي
          مستخدم آخر ، بما في ذلك أي حساب على “ قنوات / منصات تطبيق سبورتينج” غير المملوكة لك ، مصدر أو استغلال “ قنوات
          / منصات تطبيق سبورتينج” أو أي خدمة أو معلومات يتم توفيرها أو تقديمها بواسطة المنصة أو من خلالها ، بأي طريقة
          يكون الغرض منها الكشف عن أي معلومات ، بما في ذلك على سبيل المثال لا الحصر ، التعريف الشخصي أو المعلومات ، من
          المعلومات الخاصة بك ، على النحو المنصوص عليه في النظام الأساسي.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لا يجوز لك الإدلاء بأي بيان (عبارات) أو تعليقات سلبية أو تشهيرية أو تشهيرية عنا أو عن اسم العلامة التجارية أو
          اسم المجال الذي نستخدمه بما في ذلك اسم "سبورتنج" ، أو الانخراط في أي سلوك أو إجراء قد يشوه صورة أو سمعة لـ
          Sporting أو بائع على “ قنوات / منصات تطبيق سبورتينج” أو تشوه أو تخفف من أي علامات تجارية أو خدمات سبورتينج أو
          اسم تجاري و/ أو شهرة مرتبطة بهذه العلامات التجارية أو علامات الخدمة ، كما قد تكون مملوكة لنا أو نستخدمها . أنت
          توافق على أنك لن تتخذ أي إجراء يفرض عبئًا غير معقول أو كبير بشكل غير متناسب على البنية التحتية "“قنوات / منصات
          تطبيق سبورتينج” أو أنظمة أو شبكات Sporting أو أي أنظمة أو شبكات متصلة بـ Sporting .
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت توافق على عدم استخدام أي جهاز أو برنامج أو روتين للتدخل أو محاولة التدخل في العمل السليم لـ “ قنوات /
          منصات تطبيق سبورتينج” أو أي معاملة يتم إجراؤها على “ قنوات / منصات تطبيق سبورتينج” ، أو مع أي شخص آخر. استخدام
          “ قنوات / منصات تطبيق سبورتينج” .
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لا يجوز لك تزوير العناوين أو التلاعب بالمعرفات بطريقة أخرى لإخفاء أصل أي رسالة أو إرسال ترسله إلينا على أو من
          خلال “ قنوات / منصات تطبيق سبورتينج” أو أي خدمة معروضة على أو من خلال “قنوات / منصات تطبيق سبورتينج” لا يجوز
          لك التظاهر بأنك شخص آخر ، أو أنك تمثل شخصًا آخر ، أو تنتحل شخصية أي فرد أو كيان آخر.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لا يجوز لك استخدام “ قنوات / منصات تطبيق سبورتينج” أو أي محتوى على “ قنوات / منصات تطبيق سبورتينج” لأي غرض غير
          قانوني أو محظور بموجب شروط الاستخدام هذه ، أو لطلب أداء أي نشاط غير قانوني أو نشاط آخر ينتهك حقوق سبورتنج و /
          أو الآخرين.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          يجب عليك في جميع الأوقات ضمان الامتثال الكامل للأحكام المعمول بها ، بصيغتها المعدلة من وقت لآخر ، من (أ) قانون
          تكنولوجيا المعلومات ، (ب) جميع القوانين والقواعد واللوائح المحلية المعمول بها (بما في ذلك أحكام أي قوانين
          سارية لمراقبة الصرف أو اللوائح السارية) ؛ و (ج) القوانين الدولية وقوانين الصرف الأجنبي والقوانين والمراسيم
          واللوائح (بما في ذلك ، على سبيل المثال لا الحصر ، ضريبة المبيعات وضريبة الدخل وضريبة الخدمة والرسوم الجمركية
          والرسوم المحلية) فيما يتعلق باستخدامك لخدمتنا وإدراجك في القائمة والشراء ، استجداء عروض لشراء وبيع المنتجات أو
          الخدمات. لا يجوز لك المشاركة في أي معاملة في عنصر أو خدمة ، وهو أمر محظور بموجب أحكام أي قانون معمول به بما في
          ذلك قوانين أو لوائح مراقبة الصرف السارية في الوقت الحالي.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          من أجل السماح لنا باستخدام المعلومات التي قدمتها ، دون انتهاك حقوقك أو أي قوانين ، فإنك توافق على منحنا حقًا
          غير حصري ، عالمي ، دائم ، غير قابل للإلغاء ، خالي من حقوق الملكية ، قابل للترخيص من الباطن (من خلال مستويات
          متعددة) لممارسة حقوق النشر أو الدعاية أو حقوق قاعدة البيانات أو أي حقوق أخرى لديك في معلوماتك ، في أي وسائط
          معروفة الآن أو غير معروفة حاليًا ، فيما يتعلق بمعلوماتك. سنستخدم معلوماتك فقط وفقًا لشروط الاستخدام وسياسة
          الخصوصية المطبقة على استخدام “ قنوات / منصات تطبيق سبورتينج” .
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لا يجوز لك المشاركة في الإعلان أو التماس المستخدمين الآخرين للمنصة لشراء أو بيع أي منتجات أو خدمات ، بما في
          ذلك ، على سبيل المثال لا الحصر ، المنتجات أو الخدمات ذات الصلة بتلك التي يتم عرضها على المنصة أو المتعلقة بنا.
          لا يجوز لك إرسال أي رسائل متسلسلة أو بريد إلكتروني تجاري أو بريد إلكتروني غير مرغوب فيه إلى مستخدمين آخرين عبر
          المنصة. يعتبر استخدام أي معلومات تم الحصول عليها من المنصة انتهاكًا لشروط الاستخدام هذه من أجل مضايقة شخص آخر
          أو الإساءة إليه أو إلحاق الضرر به ، أو من أجل الاتصال بشخص آخر غيرنا أو الإعلان عنه أو التماسه أو بيعه.
          موافقتنا الصريحة المسبقة. من أجل حماية مستخدمينا من مثل هذا الإعلان أو الالتماس ، نحتفظ بالحق في تقييد عدد
          الرسائل أو رسائل البريد الإلكتروني التي قد يرسلها المستخدم إلى مستخدمين آخرين في أي فترة 24 ساعة نراها مناسبة
          وفقًا لتقديرها الخاص. أنت تدرك أن لدينا الحق في جميع الأوقات في الكشف عن أي معلومات (بما في ذلك هوية الأشخاص
          الذين يقدمون المعلومات أو المواد على المنصة) حسب الضرورة لتلبية أي قانون أو لائحة أو طلب حكومي صالح. قد يشمل
          ذلك ، على سبيل المثال لا الحصر ، الكشف عن المعلومات فيما يتعلق بالتحقيق في نشاط غير قانوني مزعوم أو التماس
          نشاط غير قانوني أو استجابة لأمر قضائي قانوني أو استدعاء. بالإضافة إلى ذلك ، يمكننا (وأنت تفوضنا صراحة بموجب
          هذا) الكشف عن أي معلومات عنك إلى مسؤولي إنفاذ القانون أو غيرهم من المسؤولين الحكوميين ، حيث نعتقد ، وفقًا
          لتقديرنا الخاص ، أن ذلك ضروريًا أو مناسبًا فيما يتعلق بالتحقيق و / أو القرار المحتمل الجرائم ، خاصة تلك التي
          قد تنطوي على إصابة شخصية.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نحن نحتفظ بالحق ، ولكن ليس لدينا أي التزام ، بمراقبة المواد المنشورة على المنصة. يحق لـ Sporting إزالة أو
          تعديل أي محتوى ينتهك ، أو يُزعم أنه ينتهك ، وفقًا لتقديرها الخاص ، أي قانون معمول به أو روح أو نص شروط
          الاستخدام هذه. بصرف النظر عن هذا الحق ، تظل مسؤولاً وحدك عن محتوى المواد التي تنشرها على المنصة وفي رسائلك
          الخاصة. يرجى العلم أن هذا المحتوى المنشور لا يعكس بالضرورة وجهات النظر الخاصة بسبورتينج . لن تتحمل Sporting
          بأي حال من الأحوال أي مسؤولية أو التزام تجاه أي محتوى منشور أو عن أي مطالبات أو أضرار أو خسائر ناتجة عن
          استخدام المحتوى و/أو ظهور المحتوى على المنصة. أنت تقر وتضمن بموجب هذا أن لديك جميع الحقوق اللازمة في وإلى كل
          المحتوى الذي تقدمه وجميع المعلومات التي يحتوي عليها وأن هذا المحتوى لا ينتهك أي حقوق ملكية أو حقوق أخرى لأطراف
          ثالثة أو يحتوي على أي معلومات تشهيرية أو مؤذية أو غير قانونية بأي شكل آخر. .
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          مراسلاتك أو تعاملاتك التجارية مع المعلنين الموجودين على المنصة أو من خلالها ، أو مشاركتك في العروض الترويجية ،
          بما في ذلك الدفع وتسليم المنتجات أو الخدمات ذات الصلة ، وأي شروط أو ضمانات أو إقرارات مرتبطة بهذه التعاملات ،
          هي فقط بينكما ومثل هذا المعلن. لن نكون مسؤولين أو مسؤولين عن أي خسارة أو ضرر من أي نوع يحدث نتيجة لأي من هذه
          المعاملات أو نتيجة لوجود هؤلاء المعلنين على المنصة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          من الممكن أن يقوم المستخدمون الآخرون (بما في ذلك المستخدمين غير المصرح لهم أو "المتسللين") بنشر أو نقل مواد
          مسيئة أو فاحشة على المنصة وقد تتعرض قسريًا لمثل هذه المواد المسيئة والفاحشة. من الممكن أيضًا للآخرين الحصول
          على معلومات شخصية عنك بسبب استخدامك للمنصة ، وقد يستخدم المستلم هذه المعلومات لمضايقتك أو إيذائك. نحن لا نوافق
          على مثل هذه الاستخدامات غير المصرح بها ، ولكن باستخدام المنصة ، فإنك تقر وتوافق على أننا لسنا مسؤولين عن
          استخدام أي معلومات شخصية تكشف عنها أو تشاركها علنًا مع الآخرين على المنصة. يرجى تحديد نوع المعلومات التي تكشف
          عنها علنًا أو تشاركها مع الآخرين على المنصة بعناية.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          تتمتع Sporting بجميع الحقوق في اتخاذ الإجراءات اللازمة والمطالبة بالتعويضات التي قد تحدث بسبب مشاركتك بأي شكل
          من الأشكال بمفردك أو من خلال مجموعة / مجموعات من الأشخاص ، عن قصد أو عن غير قصد في DoS / DDoS ( الرفض الموزع
          للخدمات ) ، القرصنة ومحاولات اختبار القلم دون موافقتنا المسبقة أو اتفاق قانوني متبادل.
        </li>
      </ul>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        <span style={{ textDecoration: "underline" }}>
          <strong>
            <em>تسجيل الحساب أو استخدام المنصة</em>
          </strong>
        </span>
      </p>
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          يمكنك الوصول إلى المنصة عن طريق التسجيل لإنشاء حساب ("حساب سبورتينج") وتصبح عضوًا ("العضوية") ؛ العضوية محدودة
          لهذا الغرض وتخضع للشروط وغير قابلة للتحويل بشكل صارم.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          سننشئ حساب Sporting الخاص بك لاستخدامك لخدمات المنصة بناءً على المعلومات الشخصية التي تقدمها لنا كما هو موضح
          أعلاه. يحق لك امتلاك حساب واحد فقط ولا يُسمح لك بإنشاء حسابات متعددة. إذا وجدت ، لديك حسابات متعددة ، فإن
          Sporting تحتفظ بالحق في تعليق هذا الحساب المتعدد دون أن تكون مسؤولاً عن أي تعويض.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت توافق على تقديم معلومات دقيقة وحديثة وكاملة أثناء عملية التسجيل وتحديث هذه المعلومات لإبقائها دقيقة وحديثة
          وكاملة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نحتفظ بالحق في تعليق أو إنهاء حسابك الرياضي ووصولك إلى الخدمات (1) إذا ثبت أن أي معلومات مقدمة أثناء عملية
          التسجيل أو بعد ذلك غير دقيقة أو غير حديثة أو غير كاملة ؛ (2) إذا كان يعتقد أن أفعالك قد تسبب مسؤولية قانونية
          لك أو للمستخدمين الآخرين أو لنا ؛ و / أو (3) إذا تبين أنك غير متوافق مع شروط الاستخدام.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت مسؤول عن حماية كلمة المرور الخاصة بك. أنت توافق على أنك لن تكشف عن كلمة المرور الخاصة بك لأي طرف ثالث وأنك
          ستتحمل وحدك المسؤولية عن أي أنشطة أو إجراءات تحت حسابك الرياضي ، سواء كنت قد سمحت بهذه الأنشطة أو الإجراءات أم
          لا. سوف تخطرنا على الفور بأي استخدام غير مصرح به لحسابك.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          السلع والخدمات المشتراة من المنصة مخصصة لاستخدامك الشخصي وأنت تقر بأن هذه السلع والخدمات نفسها ليست لإعادة
          البيع أو أنك لا تعمل كوكيل لأطراف أخرى.
        </li>
      </ul>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        <span style={{ textDecoration: "underline" }}>
          <em>
            <strong>الحجوزات والشروط المالية</strong>
          </em>
        </span>
      </p>
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          تتيح لك المنصة إجراء حجوزات الطلبات وسنقوم ، وفقًا للشروط والأحكام المنصوص عليها هنا ، بتمكين تسليم هذا الطلب
          إليك.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لا تملك شركة Sporting أو تبيع أو تعيد بيعها من تلقاء نفسها و / أو لا تتحكم في البائعين أو الخدمات ذات الصلة
          المقدمة فيما يتعلق بهم. أنت تدرك أن أي طلب تقدمه يجب أن يخضع للشروط والأحكام المنصوص عليها في شروط الاستخدام
          هذه بما في ذلك ، على سبيل المثال لا الحصر ، توفر المنتج وإمكانية الخدمة في موقع التسليم.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          كقاعدة عامة ، يتم التعامل مع جميع الطلبات الموضوعة على المنصة على أنها مؤكدة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          ومع ذلك ، عند الانتهاء بنجاح من حجز أحد الطلبات ، قد نتصل بك على رقم الهاتف أو الهاتف المحمول المقدم لتأكيد
          تفاصيل الطلب والسعر الذي يتعين دفعه ووقت التسليم المقدر. لهذا الغرض ، سيُطلب منك مشاركة معلومات معينة معنا ،
          بما في ذلك على سبيل المثال لا الحصر (1) اسمك الأول واسم عائلتك (2) رقم هاتفك المحمول ؛ و (3) العنوان (4) عنوان
          البريد الإلكتروني. ستكون مسؤوليتك وحدك هي لفت انتباهنا إلى أي تفاصيل غير صحيحة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          بالإضافة إلى ما سبق ، يجوز لنا أيضًا الاتصال بك عبر الهاتف و / أو البريد الإلكتروني لإبلاغك وتأكيد أي تغيير في
          الطلب ، بسبب التوفر أو عدم التوفر أو التغيير في سعر الطلب على النحو الذي أبلغ به البائع. يرجى ملاحظة أن
          التغيير أو تأكيد الطلب سيعامل على أنه نهائي. من الواضح أن Sporting تحتفظ بالحق في عدم معالجة طلبك في حالة عدم
          تواجدك على الهاتف في الوقت الذي نتصل بك فيه لتأكيد الطلب ، وفي مثل هذه الحالة ، تسري أحكام سياسة الإلغاء
          والاسترداد أدناه.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          يجب أن تكون جميع المدفوعات التي يتم سدادها مقابل المشتريات / الخدمات على المنصة من جانبك إلزاميًا بالريال
          القطري المقبولة في دولة قطر. لن تسهل المنصة المعاملات فيما يتعلق بأي شكل آخر من أشكال العملة فيما يتعلق
          بالمشتريات التي تتم على المنصة. يمكنك الدفع عن طريق (1) بطاقة الائتمان أو بطاقة الخصم أو صافي الخدمات المصرفية
          أو نقدًا في وقت التسليم. أنت تدرك وتقبل وتوافق على أن تسهيلات الدفع التي توفرها Sporting ليست خدمة مصرفية أو
          خدمة مالية ولكنها مجرد مُيسِّر يوفر دفعًا إلكترونيًا آليًا عبر الإنترنت ، ويتلقى الدفع عند التسليم ، وتسهيلات
          التحصيل والتحويل للمعاملات على المنصة باستخدام البنية التحتية المصرفية الحالية المعتمدة وشبكات بوابات الدفع
          ببطاقات الائتمان. علاوة على ذلك ، من خلال توفير تسهيلات الدفع ، لا تعمل Sporting بصفتها أمناء ولا تعمل بصفة
          ائتمانية فيما يتعلق بالمعاملة أو سعر المعاملة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت تقر وتوافق على أننا نعمل كوكيل دفع للمورّد لغرض محدود وهو قبول المدفوعات منك نيابة عن البائع. عند دفعك
          للمبالغ المستحقة للبائع ، يكتمل التزامك بالدفع للبائع مقابل هذه المبالغ ، ونحن مسؤولون عن تحويل هذه المبالغ
          إلى البائع. لا يجوز لك ، تحت أي ظرف من الظروف ، إجراء أي مدفوعات مباشرة للبائع مقابل المشتريات / الحجوزات التي
          تتم باستخدام المنصة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت توافق على أن تدفع لنا المبلغ الإجمالي للطلب الذي قدمته على المنصة. سنقوم بتحصيل المبلغ الإجمالي وفقًا
          لشروط وأحكام شروط الاستخدام هذه وشروط التسعير المنصوص عليها في قائمة القائمة المعمول بها للمورد. يرجى ملاحظة
          أنه لا يمكننا التحكم في أي مبلغ قد يفرضه عليك البنك الذي تتعامل معه فيما يتعلق بتحصيلنا للمبلغ الإجمالي ، ونحن
          نخلي مسؤوليتنا في هذا الصدد.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          فيما يتعلق بطلبك ، سيُطلب منك تقديم معلومات الفواتير المعتادة مثل الاسم وعنوان إرسال الفواتير ومعلومات بطاقة
          الائتمان إما لنا أو لمعالج الدفع التابع لجهة خارجية. أنت توافق على أن تدفع لنا مقابل الطلب الذي قدمته على
          المنصة ، وفقًا لهذه الشروط ، باستخدام الطرق الموضحة في الفقرة 5 (6) أعلاه. أنت تصرح بموجبه بتحصيل هذه المبالغ
          عن طريق شحن بطاقة الائتمان المقدمة كجزء من طلب الحجز ، إما بشكل مباشر من قبلنا أو بشكل غير مباشر ، عبر معالج
          دفع عبر الإنترنت تابع لجهة خارجية أو عن طريق إحدى طرق الدفع الموضحة على المنصة. إذا تم توجيهك إلى معالج الدفع
          التابع لجهة خارجية ، فقد تخضع للشروط والأحكام التي تحكم استخدام خدمة هذا الطرف الثالث وممارسات جمع المعلومات
          الشخصية لهذا الطرف الثالث. يرجى مراجعة هذه الشروط والأحكام وسياسة الخصوصية قبل استخدام خدمات المنصة. بمجرد
          اكتمال معاملة الحجز المؤكدة ، ستتلقى رسالة تأكيد بالبريد الإلكتروني تلخص الحجز المؤكد.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          سيصدر البائع فاتورة الضريبة النهائية إلى المشتري جنبًا إلى جنب مع الطلب ، وتقوم Sporting فقط بتحصيل المدفوعات
          نيابة عن هذا البائع. يتم تحصيل وتحديد جميع الضرائب والرسوم المطبقة ومعدلاتها وطريقة تطبيق هذه الضرائب على
          الفاتورة من قبل البائع. لا تتحمل شركة سبورتنج أية مسؤولية عن صحة / صحة جباية هذه الضرائب. تقع المسؤولية
          الوحيدة عن أي مشكلة قانونية تنشأ عن الضرائب على عاتق البائع.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          الأسعار المنعكسة في ”قنوات / منصات تطبيق سبورتينج” يحددها البائع فقط ويتم سردها بناءً على معلومات البائع. في
          حالات نادرة جدًا ، قد تتغير الأسعار في وقت تقديم الطلب نظرًا لتغيير البائع لسعر القائمة دون التنبيه الواجب ،
          ويكون هذا التغيير في السعر وفقًا لتقدير البائع المطلق نظرًا لعوامل مختلفة خارجة عن السيطرة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          إخلاء المسؤولية: قد تنعكس الأسعار على أي منتج (منتجات) كما ينعكس على المنصة بسبب بعض المشكلات الفنية أو خطأ
          مطبعي أو معلومات المنتج المقدمة من البائع بشكل غير صحيح وفي مثل هذه الحالة يجوز للبائع إلغاء هذا الطلب
          (طلباتك).
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          يتحمل البائع وحده المسؤولية عن أي ضمان للمنتجات الغذائية التي يتم بيعها للمستخدمين ولن يكون مسئولية شركة
          سبورتنج بأي حال من الأحوال .
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          الصفقة ثنائية بين البائع والمستخدم ، وبالتالي ، فإن Sporting ليست مسؤولة عن فرض أو إيداع أي ضرائب مطبقة على
          هذه المعاملة.
        </li>
      </ul>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        <span style={{ textDecoration: "underline" }}>
          <strong>
            <em>شرط الخدمة</em>
          </strong>
        </span>
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        أن توافق وتقر بأننا لسنا مسؤولين عنها.
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        أ الخدمات أو السلع التي يقدمها البائع بما في ذلك ، على سبيل المثال لا الحصر ، شراء السلع وطلبات الطعام وحجوزات
        المواعيد والخدمات التي تناسب متطلباتك واحتياجاتك
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        ب لا تتوافق خدمات أو سلع المورّد مع توقعاتك أو تؤدي إلى أي خسارة أو ضرر أو ضرر يلحق بك
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        ج توفر أو عدم توفر بعض العناصر المدرجة في " قنوات / منصات تطبيق سبورتينج"
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        د قيام البائع بإرسال / حجز / تقديم منتجات / خدمات غير صحيحة.
      </p>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          تستند تفاصيل قائمة الأسعار المتوفرة على المنصة إلى المعلومات المقدمة من البائعين ولن نتحمل المسؤولية عن أي
          تغيير أو إلغاء أو عدم توفر.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          قد لا تتمكن من الاستفادة من خدماتنا إذا كان موقع التسليم الخاص بك خارج نطاق خدمة Sporting / البائع الحالي.
          سنبقيك على اطلاع بذلك في وقت تأكيد حجز طلبك.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت تدرك أن فترات التسليم / الطلبات المسبقة / الخدمات المحجوزة مسبقًا المُقتبسة لك وقت تأكيد الطلب هي تقدير
          تقريبي وقد تختلف. لن تكون سبورتنج مسؤولة عن أي تأخير في تسليم طلبك.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          في حالة وجود عنصر قابل للتسليم ، سيتم تسليم طلبك فقط إلى العنوان الذي حددته في وقت تقديم الطلب على المنصة.
          نحتفظ بالحق في إلغاء الطلب ، وفقًا لتقديرنا الخاص ، في حالة حدوث أي تغيير في مكان التسليم ولا يحق لك استرداد
          أي مبلغ مقابل ذلك. يكون التسليم في حالة تغيير موقع التسليم وفقًا لتقديرنا الخاص.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          يجب أن تتعهد بتقديم التوجيهات والمعلومات والتفويضات الكافية لقبول التسليم أو حجز خدمة معينة. في حالة أي إخفاق
          في قبول موعد التسليم / الحضور أو الحجز ، أو عدم التسليم في غضون الوقت المقدر بسبب إخفاقك في تقديم التعليمات أو
          التفويضات المناسبة ، عندئذٍ تعتبر هذه السلع والخدمات قد تم تسليمها لك وجميع تنتقل المخاطرة والمسؤولية فيما
          يتعلق بهذه البضائع إليك ولا يحق لك استرداد أي مبلغ عنها. سيكون قرارنا فيما يتعلق بهذا الأمر نهائيًا وملزمًا.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت تدرك أن مسؤوليتنا تنتهي بمجرد تأكيد خدمتك مع جميع الوثائق المطلوبة بما في ذلك قسائم الدفع (إن وجدت) لك.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت تؤكد أننا لسنا مسؤولين عن أي نقص في دفع المقابل المستحق الدفع مقابل البضائع المشتراة من الخدمات
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          قد تحتوي كل عملية شراء أو خدمة على التعليمات اللازمة لاسترداد الخدمات. تخضع شروط الخدمات لشروط الاستخدام هذه
          وأي شروط أخرى على النحو المنصوص عليه في هذه الوثيقة تؤكد بيع الخدمة. لا يحق لك الحصول على أي ائتمان أو استرداد
          أو استرداد نقدي لقيمة البضائع المباعة إذا فشلت في استرداد البضائع خلال تاريخ انتهاء الصلاحية أو وفقًا للشروط
          الواردة فيه.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت توافق وتقر بأنه لن نتحمل نحن ولا المورد المسؤولية في حالة عدم التزامك بشروط الاستخدام
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          قد يُطلب منك تقديم تفاصيل بطاقة الائتمان أو الخصم الخاصة بك إلى بوابات الدفع المعتمدة أثناء إجراء الدفع. في
          هذا الصدد ، أنت توافق على تقديم تفاصيل صحيحة ودقيقة لبطاقة الائتمان / الخصم لبوابات الدفع المعتمدة للاستفادة
          من الخدمات. لا يجوز لك استخدام بطاقة الائتمان / الخصم التي لا تملكها بشكل قانوني ، أي في أي معاملة ، يجب عليك
          استخدام بطاقة الائتمان / الخصم الخاصة بك. لن يتم استخدام المعلومات التي قدمتها أو مشاركتها مع أي طرف ثالث ما
          لم يكن ذلك مطلوبًا فيما يتعلق بالتحقق من الاحتيال أو بموجب القانون أو اللوائح أو أمر المحكمة. ستكون مسؤولاً
          بمفردك عن أمان وسرية تفاصيل بطاقة الائتمان / الخصم الخاصة بك. نحن نخلي مسؤوليتنا صراحة عن جميع الالتزامات التي
          قد تنشأ نتيجة أي استخدام غير مصرح به لبطاقة الائتمان / الخصم الخاصة بك.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لا نقدم أي مبالغ مستردة مقابل البضائع التي تم شراؤها بالفعل من المنصة ما لم يحدث خطأ منسوب إلينا بشكل مباشر
          أثناء شراء هذا المنتج أو الخدمات.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نحن نسعى باستمرار لتزويدك بمعلومات دقيقة على المنصة. ومع ذلك ، في حالة حدوث خطأ ، يجوز لنا ، وفقًا لتقديرنا
          الخاص ، الاتصال بك لإبلاغك بمزيد من الإرشادات
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          إذا كنت تستخدم النظام الأساسي ، فأنت تفعل الشيء نفسه على مسؤوليتك الخاصة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت توافق على أن الخدمات يجب أن نقدمها فقط خلال ساعات عمل البائعين المعنيين
        </li>
      </ul>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        <span style={{ textDecoration: "underline" }}>
          <strong>
            <em>
              شروط محددة فيما يتعلق باستخدام النظام الأساسي لشراء الأدوية والمنتجات الصيدلانية التي تتطلب وصفة طبية
            </em>
          </strong>
        </span>
      </p>
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          يمكنك استخدام المنصة لشراء العديد من الأدوية والمنتجات الصيدلانية من متاجر الصيدليات التي تتطلب وصفة طبية
          سارية المفعول صادرة عن خبير طبي / طبيب ليتم تقديمها إلى صيدلي مسجل لغرض صرف هذه الأدوية والمنتجات الصيدلانية
          ("الوصفة الطبية" الأدوية ") المعروضة للبيع على المنصة بواسطة البائع. من أجل شراء الأدوية الموصوفة من البائع
          عبر المنصة ، يتعين عليك تحميل نسخة ممسوحة ضوئيًا من الوصفة الطبية الصالحة على المنصة. لن تتم معالجة الطلب حتى
          يتم تحميل نسخة من وصفة طبية صالحة على المنصة. سيتحقق البائع من الوصفة الطبية التي قمت بتحميلها وفي حالة ملاحظة
          البائع لأي تناقض في الوصفة الطبية التي قمت بتحميلها ، فسيتم إلغاء الطلب على الفور. أنت مطالب أيضًا بإتاحة
          الوصفة الطبية الأصلية في وقت استلام توصيل الأدوية الموصوفة. يجب أن تسمح لشريك التوصيل بختم الوصفة الأصلية في
          وقت تسليم الدواء ، وإلا فلن يتم تسليم الأدوية.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت تدرك وتوافق على أن “ قنوات / منصات تطبيق سبورتينج” هي مجرد منصة تقنية وأن الأدوية والمنتجات الصيدلانية
          يبيعها البائع لك. لن تكون “ قنوات / منصات تطبيق سبورتينج” مسؤولة بأي شكل من الأشكال عن أي خطأ أو إغفال أو فعل
          يرتكب من جانب البائع.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت تمنح الحق في " قنوات / منصات تطبيق سبورتينج" لمشاركة نسخة من الوصفة الطبية التي قمت بتحميلها مع البائع
          للتحقق من الوصفة الطبية ولكي يقوم البائع بتوزيع الأدوية الموصوفة وفقًا لذلك.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت توافق وتتعهد بأنك لن تكرر استخدام الوصفات الطبية التي تم صرف الأدوية من أجلها بالفعل. في حالة ملاحظة أنك
          تكرر استخدام الوصفة الطبية ، فسيتم إلغاء الأمر على الفور. في أي حال ، لن تكون “ قنوات / منصات تطبيق سبورتينج”
          مسؤولة عن أي آثار ضارة أو ضرر يلحق بك إذا كررت استخدام الوصفات الطبية لطلب العقاقير التي تستلزم وصفة طبية من
          خلال المنصة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت توافق وتؤكد أنك على دراية كاملة بالمؤشرات ، والآثار الجانبية ، والتفاعلات الدوائية ، وآثار الجرعات الفائتة
          أو الجرعات الزائدة من الأدوية التي تطلبها من خلال المنصة. من الضروري طلب المشورة المهنية من طبيبك قبل شراء أو
          استهلاك أي دواء.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          يجب أن يحتفظ تطبيق البائع / التطبيق الرياضي بسجل للوصفات الطبية التي تم تحميلها من قبل المستخدمين.
        </li>
      </ul>
      <br />
      <h3>
        <span style={{ textDecoration: "underline" }}>
          <strong>
            <em>الوصول إلى المنصة والدقة والأمان.</em>
          </strong>
        </span>
      </h3>
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نسعى جاهدين لإتاحة المنصة خلال ساعات عمل البائعين. ومع ذلك ، فإننا لا نقر بأن الوصول إلى المنصة سيكون دون
          انقطاع ، وفي الوقت المناسب ، وخالٍ من الأخطاء ، وخالٍ من الفيروسات أو المكونات الضارة الأخرى أو أنه سيتم تصحيح
          هذه العيوب.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لا نضمن أن تكون المنصة متوافقة مع جميع الأجهزة والبرامج التي قد تستخدمها. لن نكون مسؤولين عن أي ضرر أو فيروسات
          أو تعليمات برمجية أخرى قد تؤثر على أي معدات (بما في ذلك على سبيل المثال لا الحصر جهازك المحمول) أو البرامج أو
          البيانات أو الممتلكات الأخرى نتيجة تنزيلك أو تثبيته أو الوصول إليه أو استخدامه المنصة أو حصولك على أي مواد من
          أو نتيجة لاستخدامها. لن نكون مسؤولين عن أفعال الأطراف الثالثة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نحن لا نؤكد أو نضمن أن المعلومات المتاحة على المنصة ستكون صحيحة أو دقيقة أو موثوقة بطريقة أخرى.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نحتفظ بالحق في تعليق أو سحب الوصول إلى المنصة لك شخصيًا ، أو لجميع المستخدمين بشكل مؤقت أو دائم في أي وقت دون
          إشعار. يجوز لنا في أي وقت وفقًا لتقديرنا الخاص إعادة المستخدمين المعلقين. لا يجوز للمستخدم الموقوف التسجيل أو
          محاولة التسجيل معنا أو استخدام المنصة بأي طريقة كانت حتى يحين الوقت الذي يتم فيه إعادة هذا المستخدم من قبلنا.
        </li>
      </ul>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        <span style={{ textDecoration: "underline" }}>
          <strong>
            <em>العلاقة مع المشغلين إذا تم الوصول إلى النظام الأساسي على الأجهزة المحمولة.</em>
          </strong>
        </span>
      </p>
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          في حالة الوصول إلى النظام الأساسي على جهاز محمول ، فهو غير مرتبط أو منتسب أو مدعوم أو معتمد أو مرتبط بأي شكل
          من الأشكال بأي مشغل منصة ، بما في ذلك ، على سبيل المثال لا الحصر ، Apple أو Google أو Android أو RIM
          Blackberry كل منها " المشغل أو العامل"
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          إن تحميلك للمنصة أو تثبيتها أو الوصول إليها أو استخدامها مرتبط أيضًا بشروط وأحكام المشغل.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نحن وأنت نقر بأن شروط الاستخدام هذه مبرمة بينك وبيننا فقط ، وليس مع مشغل ، ونحن ، وليس هؤلاء المشغلون ،
          مسؤولون وحدنا عن المنصة ومحتواها إلى الحد المحدد في شروط الاستخدام هذه.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          يقتصر الترخيص الممنوح لك للمنصة على ترخيص غير قابل للتحويل لاستخدام النظام الأساسي على جهاز محمول تملكه أو
          تتحكم فيه ووفقًا لما تسمح به شروط الاستخدام هذه.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نحن مسؤولون وحدنا عن تقديم أي خدمات صيانة ودعم فيما يتعلق بالمنصة كما هو مطلوب بموجب القانون المعمول به. نحن
          وأنت نقر بأن المشغل ليس لديه أي التزام من أي نوع لتقديم أي خدمات صيانة ودعم فيما يتعلق بالمنصة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نحن وأنت نقر بأننا ، وليس المشغل المعني ، مسؤولون عن معالجة أي مطالبات منك أو من أي طرف ثالث فيما يتعلق
          بالمنصة أو حيازتك و / أو استخدامك للمنصة ، بما في ذلك ، على سبيل المثال لا الحصر: (1) أي الادعاء بأن المنصة لا
          تتوافق مع أي متطلبات قانونية أو تنظيمية سارية ؛ و (2) المطالبات الناشئة بموجب حماية المستهلك أو تشريعات
          مماثلة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نحن وأنت نقر بأنه في حالة وجود أي ادعاء من طرف ثالث بأن النظام الأساسي أو امتلاكك واستخدامك للمنصة ينتهك حقوق
          الملكية الفكرية لهذا الطرف الثالث ، فإننا ، وليس المشغل المعني ، سنتحمل وحدنا المسؤولية عن التحقيق والدفاع
          وتسوية وإبراء ذمة أي دعوى تتعلق بانتهاك حقوق الملكية الفكرية.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          يجب عليك الامتثال لأي شروط اتفاقية سارية من جهة خارجية عند استخدام المنصة (على سبيل المثال ، يجب عليك التأكد
          من أن استخدامك للمنصة لا ينتهك اتفاقية جهازك المحمول أو أي اتفاقية خدمة بيانات لاسلكية).
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نحن وأنت نقر ونوافق على أن المشغل المعني ، والشركات التابعة له ، هم أطراف ثالثة مستفيدة من شروط الاستخدام هذه
          ، وأنه عند موافقتك على شروط الاستخدام هذه ، سيكون لهذا المشغل الحق (وسيعتبر أنه قبلت بالحق) لفرض شروط
          الاستخدام هذه عليك بصفتك طرفًا ثالثًا مستفيدًا منها.
        </li>
      </ul>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        <br />
        <span style={{ textDecoration: "underline" }}>
          <strong>
            <em>10. إخلاء المسؤولية</em>
          </strong>
        </span>
      </p>
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          قد تكون المنصة في حالة تحديثات ثابتة ، وقد لا تعمل بعض الوظائف والميزات بشكل كامل.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          بسبب التفاوتات التي يمكن أن تحدث في التوزيع الإلكتروني للمعلومات وبسبب القيود المتأصلة في تقديم المعلومات التي
          يتم الحصول عليها من مصادر متعددة ، فقد يكون هناك تأخيرات أو عمليات حذف أو عدم دقة في محتوى العرض المقدم أو
          التأخير المنصة. ونتيجة لذلك ، فإننا لا نقر بأن المعلومات المنشورة صحيحة في كل حالة.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          نحن نخلي مسؤوليتنا صراحة عن جميع المسؤوليات التي قد تنشأ كنتيجة لأي استخدام غير مصرح به لبطاقات الائتمان /
          المدين.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          أنت تقر بأن خدمات الطرف الثالث متوفرة على المنصة. قد يكون لدينا شراكات أو تحالفات مع بعض هذه الأطراف الثالثة
          من وقت لآخر من أجل تسهيل توفير بعض الخدمات لك. ومع ذلك ، فإنك تقر وتوافق على أننا لا نقدم في أي وقت أي تعهد أو
          ضمان فيما يتعلق بخدمات أي طرف ثالث ولن نكون مسؤولين تجاهك أو تجاه أي طرف ثالث عن أي تبعات أو دعاوى تتعلق بذلك.
          على سبيل المثال لا الحصر ، أي مسؤولية أو مسؤولية عن أو وفاة أو إصابة أو انخفاض في القيمة واجهتك أنت أو أي طرف
          ثالث. أنت تُخلي مسؤوليتك وتتنازل عن أي حقوق ومطالبات قد تكون ضدنا فيما يتعلق بخدمات الطرف الثالث / البائعين.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          تخلي سبورتينج مسئوليتها وكافة المسؤوليات التي قد تنشأ بسبب أي انتهاك لمعايير سلامة الأغذية والقواعد واللوائح
          المعمول بها المنصوص عليها في هذه الاتفاقية ، ويجب أن تكون هذه المسؤولية مسؤولة أمام البائع.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          في حين أن المواد المقدمة على المنصة معدة لتقديم معلومات دقيقة فيما يتعلق بالموضوع الذي تمت مناقشته ، فإن
          المعلومات الواردة في هذه المواد تكون متاحة مع فهم أننا لا نقدم أي ضمانات ، المؤهلات المهنية أو الخبرة أو جودة
          العمل أو المعلومات الأخرى الواردة هنا. علاوة على ذلك ، فإننا لا ، بأي شكل من الأشكال ، نصادق على أي خدمة مقدمة
          أو موصوفة هنا. لن نكون مسؤولين بأي حال من الأحوال تجاهك أو تجاه أي طرف ثالث عن أي قرار تم اتخاذه أو إجراء تم
          اتخاذه بالاعتماد على هذه المعلومات.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          المعلومات المقدمة هنا مقدمة "كما هي". لا نقدم نحن و / أو موظفونا أي ضمان أو إقرار فيما يتعلق بالوقت أو المحتوى
          أو التسلسل أو الدقة أو الفعالية أو اكتمال أي معلومات أو بيانات مقدمة هنا أو أن المعلومات أو البيانات المقدمة
          هنا. قد تكون الردود المتعددة متاحة عادةً من مصادر مختلفة ، وتُترك لحكم المستخدمين بناءً على شروطهم الخاصة
          لاستخدام ، أو تعديل ، أو تعديل ، أو تبديل الاقتراحات أو استخدامها في أي من الحالات الأخرى. بالإضافة إلى
          مستشارينا وشركاء الأعمال والشركات التابعة وشركاء الأعمال والموظفين من أي نوع من أنواع المسؤولية المهنية.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لن نتحمل أي مسؤولية تجاهك أو تجاه أي شخص آخر عن أي خسائر أو إصابات ناتجة عن المعلومات المقدمة على المنصة أو
          تتعلق بها. لن نكون بأي حال من الأحوال مسئولين نحن أو موظفونا أو شركاؤنا أو مؤلفونا أو وكلاؤنا تجاهك أو تجاه أي
          طرف ثالث عن أي قرار أو إجراء تم اتخاذه من قبل اعتمادك على المحتوى المتضمن هنا.
        </li>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          لن نكون مسؤولين بأي حال من الأحوال عن أي أضرار (بما في ذلك ، على سبيل المثال لا الحصر ، أضرار مباشرة أو غير
          مباشرة أو عرضية أو خاصة أو تبعية أو نموذجية ، والأضرار الناجمة عن الإصابات الشخصية / الوفاة الخاطئة ، والأضرار
          الناتجة عن الأضرار. ) ، الناتجة عن أي خدمات يقدمها أي طرف ثالث أو بائع يتم الوصول إليه من خلال المنصة ، سواء
          كان ذلك استنادًا إلى الضمان أو العقد أو الضرر أو أي نظرية قانونية أخرى وسواء تم إخطارنا باحتمالية هذه
          المسؤولية أم لا.
        </li>
      </ul>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        <span style={{ textDecoration: "underline" }}>
          <strong>
            <em>القانون الحاكم وتسوية المنازعات</em>
          </strong>
        </span>
      </p>
      <ul>
        <li
          style={{
            color: "#000000",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            fontSize: "medium",
            fontStyle: "normal",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            orphans: 2,
            textAlign: "start",
            textIndent: "0px",
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            wordSpacing: "0px",
            WebkitTextStrokeWidth: "0px",
            textDecorationThickness: "initial",
            textDecorationStyle: "initial",
            textDecorationColor: "initial",
          }}
        >
          تخضع شروط الاستخدام هذه لقوانين دولة قطر. يخضع أي إجراء أو دعوى أو إجراء قانوني آخر ، يتم البدء فيه لحل أي
          مسألة تنشأ بموجب هذه المنصة أو تتعلق بها ، للاختصاص القضائي للمحاكم في قطر ، ولا سيما قانون الشركات التجارية
          رقم (11). ) لعام 2015.
        </li>
      </ul>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        <span style={{ textDecoration: "underline" }}>
          <strong>
            <em>اتصل بنا</em>
          </strong>
        </span>
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        إذا كانت لديك أي استفسارات تتعلق بمعالجة أو استخدام المعلومات التي قدمتها فيما يتعلق بهذه السياسة ، فيرجى
        مراسلتنا عبر البريد الإلكتروني على <a href="mailto:qureapplication@info.com">sportingapplication@info.com</a> أو
        الاتصال بعنوان مكتبنا
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        <strong>تطبيق سبورتينج</strong>
      </p>
      <br
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      />
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        عنوان Marina Twin Towers, Tower A, Floor 17, Office 171, Lusail City.
      </p>
      <p
        style={{
          color: "#000000",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          fontSize: "medium",
          fontStyle: "normal",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontWeight: 400,
          letterSpacing: "normal",
          orphans: 2,
          textAlign: "start",
          textIndent: "0px",
          textTransform: "none",
          whiteSpace: "normal",
          widows: 2,
          wordSpacing: "0px",
          WebkitTextStrokeWidth: "0px",
          textDecorationThickness: "initial",
          textDecorationStyle: "initial",
          textDecorationColor: "initial",
        }}
      >
        هاتف <a href="tel:+974%20330330000">+974 330330000</a>
      </p>
    </Box>
  );
};

export default Terms;
